var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"d":"M39.18,0C32.75,0,30.33,4.38,28,8.61c-.39.71-14.94,27.76-15.22,28.25C9.88,41.92,8,45.26,0,45.26v2.62H15.37c6.45,0,8.88-4.37,11.22-8.6.4-.72,15-27.77,15.23-28.26,2.89-5.06,4.79-8.4,12.76-8.4h0V0H39.18Z"}))));
}

Logo.defaultProps = {"viewBox":"0 0 54.58 47.88"};

module.exports = Logo;

Logo.default = Logo;
